// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.page-title {
    width: 100%;
    height: 65px;
    padding: 10px 0;
}

.dataTables_wrapper {
    position: relative;
    clear: both;
    zoom: 1;
}
.page-title .title_left {
    width: 100%;
    float: left;
    display: block;
}
.x_panel {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
    padding: 10px 17px;
    display: inline-block;
    background: #fff;
    border: 1px solid #E6E9ED;
    -webkit-column-break-inside: avoid;
    -moz-column-break-inside: avoid;
    opacity: 1;
    transition: all .2s ease;
}
.x_content {
    padding: 0 5px 6px;
    position: relative;
    width: 100%;
    float: left;
    clear: both;
    margin-top: 5px;
}
.col-md-55, .col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
    position: relative;
    min-height: 1px;
    float: left;
    padding-right: 10px;
    padding-left: 10px;
}
.dataTables_wrapper {
    position: relative;
    clear: both;
    zoom: 1;
}
/* .dataTables_length {
    width: 40%;
    float: left;
} */
.dataTables_filter {
    width: 50%;
    float: right;
    text-align: right;
}
.table-bordered {
    border: 1px solid #ddd;
}
.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    background-color: transparent;
}
.employeesTableIcons .btn {
    padding: 3px 6px !important;
}
.btn-success {
    background: #26B99A;
    border: 1px solid #169F85;
}
.btn-primary {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/Agebands.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,+BAA+B;IAC/B,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;;;GAGG;AACH;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":["\r\n.page-title {\r\n    width: 100%;\r\n    height: 65px;\r\n    padding: 10px 0;\r\n}\r\n\r\n.dataTables_wrapper {\r\n    position: relative;\r\n    clear: both;\r\n    zoom: 1;\r\n}\r\n.page-title .title_left {\r\n    width: 100%;\r\n    float: left;\r\n    display: block;\r\n}\r\n.x_panel {\r\n    position: relative;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n    padding: 10px 17px;\r\n    display: inline-block;\r\n    background: #fff;\r\n    border: 1px solid #E6E9ED;\r\n    -webkit-column-break-inside: avoid;\r\n    -moz-column-break-inside: avoid;\r\n    opacity: 1;\r\n    transition: all .2s ease;\r\n}\r\n.x_content {\r\n    padding: 0 5px 6px;\r\n    position: relative;\r\n    width: 100%;\r\n    float: left;\r\n    clear: both;\r\n    margin-top: 5px;\r\n}\r\n.col-md-55, .col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\r\n    position: relative;\r\n    min-height: 1px;\r\n    float: left;\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n}\r\n.dataTables_wrapper {\r\n    position: relative;\r\n    clear: both;\r\n    zoom: 1;\r\n}\r\n/* .dataTables_length {\r\n    width: 40%;\r\n    float: left;\r\n} */\r\n.dataTables_filter {\r\n    width: 50%;\r\n    float: right;\r\n    text-align: right;\r\n}\r\n.table-bordered {\r\n    border: 1px solid #ddd;\r\n}\r\n.table {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    margin-bottom: 20px;\r\n    background-color: transparent;\r\n}\r\n.employeesTableIcons .btn {\r\n    padding: 3px 6px !important;\r\n}\r\n.btn-success {\r\n    background: #26B99A;\r\n    border: 1px solid #169F85;\r\n}\r\n.btn-primary {\r\n    color: #fff;\r\n    background-color: #337ab7;\r\n    border-color: #2e6da4;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
